import React from 'react';
import s from './checkbox.module.css';

const Checkbox = ({ label, checked, onChange, disabled, marginTop, styleLabel }) => (
	<div
		className={`${s.vars} ${s.outerContainer} ${disabled ? s.outerContainerDisabled : ''}`}
		style={marginTop ? { marginTop: 14 } : undefined}
		onClick={!disabled ? onChange : undefined}
	>
		<div className={`${s.vars} ${s.container} ${disabled ? s.containerDisabled : ''}`}>
			{checked && <div className={`${s.fill} ${disabled ? s.fillDisabled : ''}`} />}
		</div>
		<div className={`${s.label} ${disabled ? s.labelDisabled : ''}`} style={styleLabel}>
			{label}
		</div>
	</div>
);

export default Checkbox;
